export const shareFrowWhatsApp = (indicationCode: string) => {
  const message = `Quer ter 7 dias grátis de treinos aqui? Baixe o aplicativo Gurupass clicando no link https://onelink.to/swsmt9, e ao aderir a um plano, use meu código ${indicationCode} e ganhe 7 dias grátis. Depois, é só usar seu plano para fazer checkins aqui e experimentar essa nova forma de treinos!`;

  const linkWhatsApp =
    'https://api.whatsapp.com/send?text=' + encodeURIComponent(message);
  window.open(linkWhatsApp, '_blank');
};
